import { createAction, props } from '@ngrx/store';
import {User} from "../../types";
import {USER_LOAD, USER_SET, USER_SET_LOADING_ERROR} from "./action-types";

export const loadUser = createAction(USER_LOAD);
export const setUser = createAction(USER_SET, props<User>());
export const setLoadingError = createAction(USER_SET_LOADING_ERROR);
